import Tree from './Tree';
import AlignmentTree from './AlignmentTree';
import * as treeUtil from './util';

export { Tree, treeUtil, AlignmentTree };

export default Tree;
